import { createContext, type Dispatch, type SetStateAction } from 'react';

interface RestoreEnergyContextType {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const RestoreEnergyContext = createContext({} as RestoreEnergyContextType);

export { RestoreEnergyContext };
